/**
 * File management utilities
 * Helpers for file validation, formatting, and processing
 */

// File size constants
export const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'] as const;
export const BYTES_PER_UNIT = 1024;

/**
 * Format file size to human-readable string
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';

  const unitIndex = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_UNIT));
  const size = bytes / Math.pow(BYTES_PER_UNIT, unitIndex);
  const unit = FILE_SIZE_UNITS[unitIndex] || 'B';

  return `${size.toFixed(size < 10 ? 1 : 0)} ${unit}`;
}

/**
 * Check if file is an image
 */
export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

/**
 * Create object URL for file preview (remember to revoke when done)
 */
export function createFilePreview(file: File): string | null {
  if (!isImageFile(file)) return null;

  try {
    return URL.createObjectURL(file);
  } catch (error) {
    console.error('Failed to create file preview:', error);
    return null;
  }
}

/**
 * Revoke object URL to free memory
 */
export function revokeFilePreview(url: string): void {
  try {
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to revoke file preview:', error);
  }
}
